/// <reference path="../../services/badword.service.js" />
const mod = require('../../bahabot.module.js')


/**
 * @param {BadwordService} BadwordService
 */
function bbBadwordController(BadwordService, $scope, $q) {
    this.svc = BadwordService;

    this.badwords = [];
    this.loading = false;
    this.error = null;

    this.editedBadword = null;
    this.deletedBadword = null;
    this.createdBadword = null;

    this.createError = null;
    this.deleteError = null;
    this.editError = null;

    this.startRequest = () => {
        this.loading = true;
        this.error = null;
        this.createError = null;
        this.deleteError = null;
        this.editError = null;
    }

    this.get = () => {
        this.startRequest();
        BadwordService.get()
            .then(r => {
                this.badwords = r;
            })
            .catch(e => {
                this.error = e.data.error;
            })
            .finally(() => {
                this.loading = false;
            });
    }

    this.createBadword = () => {
        this.createdBadword = {
            word: "",
            ignoreSpaces: false
        };
    }

    this.createBadwordCommit = () => {
        this.startRequest();
        BadwordService.post(this.createdBadword)
            .then(() => {
                this.dismiss();
            })
            .catch((e) => {
                this.createError = e.data.error;
            })
            .finally(() => {
                this.loading = false;
            })
    }

    this.editBadwordCommit = () => {
        this.startRequest();
        BadwordService.patch(this.editedBadword.id, this.editedBadword)
            .then(() => {
                this.dismiss();
            })
            .catch((e) => {
                this.editError = e.data.error;
            })
            .finally(() => {
                this.loading = false;
            })
    }

    this.editBadword = (badword) => {
        this.editedBadword = badword;
    }

    this.deleteBadword = (badword) => {
        this.deletedBadword = badword;
    }

    this.dismiss = () => {
        this.editedBadword = null;
        this.deletedBadword = null;
        this.createdBadword = null;

        this.get();
    }

    this.onDeleteModalAction = (e) => {
        const handler = {
            confirm: () => {
                this.startRequest();
                BadwordService.delete(this.deletedBadword.id)
                    .then(() => {
                        this.dismiss();
                    })
                    .catch((e) => {
                        this.deleteError = e.data.error;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            },
            dismiss: this.dismiss
        };

        handler[e]();
    }

    this.get();
}

mod.component('bbBadwords', {
    templateUrl: 'tpl/bb-badwords.component.html',
    bindings: {},
    controller: ["BadwordService", "$scope", "$q", bbBadwordController]
});